import { useMemo } from "react";
import { GetCompanyTeams } from "src/graphql/company";

/** Misma estructura que Configuración → Equipo (Configuracion2). */
export const DEFAULT_COMPANY_EQUIPO_TEAMS = [
  { key: "accounting", name: "Contabilidad", members: [] },
  { key: "treasury", name: "Tesorería", members: [] },
  { key: "finance", name: "Finanzas", members: [] },
  { key: "technology", name: "Tecnología", members: [] },
  { key: "collections", name: "Cobranza", members: [] },
  { key: "financial_operations", name: "Operaciones Financieras", members: [] },
  { key: "human_resources", name: "Recursos Humanos", members: [] },
  { key: "clients", name: "Clientes", members: [] },
];

/**
 * Miembros asignados en Ajustes → Equipo (getCompanyTeams).
 * No incluye todos los usuarios de la empresa, solo integrantes por área.
 */
export function useCompanyEquipoMembers(companyId) {
  const { data, fetching, error, reexecuteQuery } = GetCompanyTeams({ companyId });

  const teams = useMemo(() => {
    const fromServer = data?.getCompanyTeams;
    return Array.isArray(fromServer) && fromServer.length > 0
      ? fromServer
      : DEFAULT_COMPANY_EQUIPO_TEAMS;
  }, [data]);

  const teamsWithMembers = useMemo(
    () =>
      teams
        .map((team) => ({
          ...team,
          members: (team.members || []).filter((m) => m?.userId),
        }))
        .filter((team) => team.members.length > 0),
    [teams]
  );

  const allMembers = useMemo(() => {
    const map = new Map();
    for (const team of teams) {
      for (const m of team.members || []) {
        const id = String(m.userId || "");
        if (!id || map.has(id)) continue;
        map.set(id, {
          userId: id,
          name: m.name,
          email: m.email,
          teamKey: team.key,
          teamName: team.name,
        });
      }
    }
    return Array.from(map.values());
  }, [teams]);

  return {
    teams,
    teamsWithMembers,
    allMembers,
    totalAssigned: allMembers.length,
    fetching,
    error,
    reexecuteQuery,
    hasLoaded: Boolean(data?.getCompanyTeams?.length),
  };
}
